import { Component, Input } from '@angular/core';

@Component({
  selector: 'ipm-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
   styleUrls: ['./skeleton-loader.component.scss']
})
export class SkeletonLoaderComponent {
  @Input() loaderType: string = 'grid';
  @Input() loaderCount: number = 5;

  get loaderItems(): any[] {
    return Array.from({ length: this.loaderCount });
  }

  constructor() {}
}
